import {
  AgentComponentMode,
  AgentComponentType,
  ESCALATION_MODES,
} from '@reach/shared-types/agent-components';
import { useId } from 'react';
import { MODE_COPY } from '../agents-copy';
import { COMPONENT_PAGE_COPY } from './component-page-copy';
import styles from './ModeField.module.css';

const ALL_MODES = Object.values(AgentComponentMode);

interface ModeFieldProps {
  type: AgentComponentType;
  value: AgentComponentMode;
  onChange: (mode: AgentComponentMode) => void;
}

/** Chooses whether tenants see a component and whether they can turn it on or off. */
export const ModeField = ({ type, value, onChange }: ModeFieldProps) => {
  const groupName = useId();
  const componentIsEscalation = type === AgentComponentType.ESCALATION;
  const modes: readonly AgentComponentMode[] = componentIsEscalation ? ESCALATION_MODES : ALL_MODES;

  return (
    <fieldset className={styles.modes}>
      <legend>{COMPONENT_PAGE_COPY.modeLegend}</legend>
      {componentIsEscalation && <p>{COMPONENT_PAGE_COPY.escalationModeNote}</p>}
      {modes.map(mode => (
        <label key={mode}>
          <input
            type="radio"
            name={groupName}
            value={mode}
            checked={value === mode}
            onChange={() => onChange(mode)}
          />
          {MODE_COPY[mode].label}
          <small>{MODE_COPY[mode].description}</small>
        </label>
      ))}
    </fieldset>
  );
};
